export const transaksiJurnalFormData = (dropdownAkunDebet, dropdownAkunKredit, dropdownUnitUsaha) => {
    return [
        {
            id : "tanggal_transaksi",
            label : "Tanggal Transaksi",
            fields : [{
                type: "date"
            }]
        },
        {
            id : "id_sistem_akun_debet",
            label : "Pilih Akun Debet",
            fields : [{
                type : "option",
                options: dropdownAkunDebet
            }]
        },
        {
            id : "id_sistem_akun_kredit",
            label : "Pilih Akun Kredit",
            fields : [{
                type : "option",
                options: dropdownAkunKredit
            }]
        },
        {
            id : "id_unit_usaha",
            label : "Pilih Unit Usaha",
            fields : [{
                type : "option",
                options : dropdownUnitUsaha
            }]
        },
        {
            id : "jumlah_transaksi_jurnal",
            label: "Jumlah Transaksi",
            fields: [{
                type : "input",
                placeholder : "Masukan Jumlah Transaksi"
            }]
        },
        {
            id : "keterangan_transaksi_jurnal",
            label: "Keterangan Transaksi",
            fields: [{
                type : "input",
                placeholder : "Masukan Keterangan Transaksi"
            }]
        }
    ]
}